import React, { createContext, useContext } from 'react';

export interface SiteNavPageItem {
  id: string;
  title: string;
  route_path: string;
  status?: string;
}

export interface SiteNavigationContextValue {
  pages: SiteNavPageItem[];
  activePageId: string;
  siteName: string;
  isPreview: boolean;
  onNavigatePage: (pageId: string, routePath: string) => void;
}

const defaultContextValue: SiteNavigationContextValue = {
  pages: [
    { id: 'p1', title: 'Home', route_path: '/' },
    { id: 'p2', title: 'Courses', route_path: '/courses' },
    { id: 'p3', title: 'Results & Toppers', route_path: '/results' },
    { id: 'p4', title: 'Faculty', route_path: '/faculty' },
    { id: 'p5', title: 'Admissions', route_path: '/admissions' },
  ],
  activePageId: 'p1',
  siteName: 'Apex Coaching Academy',
  isPreview: false,
  onNavigatePage: () => {},
};

export const SiteNavigationContext = createContext<SiteNavigationContextValue>(defaultContextValue);

export function useSiteNavigation(): SiteNavigationContextValue {
  return useContext(SiteNavigationContext);
}
